import Biography from "../components/Biography/Biography";

const BioPage = () => {
  return (
    <div className="BioPage">
      <div className="m-auto text-left max-w-2xl p-4">
        <Biography />
      </div>
    </div>
  )
};

export default BioPage;